import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CarryoverUtils } from '../carryover-utils';
import { CarryoverApprovalStatus } from '../../../../../enums/carryover-approval-status.enum';

@Component({
  selector: 'app-carryover-approval-status-pill',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './carryover-approval-status-pill.component.html',
  styleUrls: ['./carryover-approval-status-pill.component.css', '../carryover-pill.scss'],
})
export class CarryoverApprovalStatusPillComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}

  protected readonly CarryoverUtils = CarryoverUtils;
  @Input() status: CarryoverApprovalStatus;
}
